/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { AnyAction, isType } from 'typescript-fsa';
import { PlayListEntry } from '../../../services/playlist';
import {
    playlistSetIsLoading,
    setPlaylistFromDate,
    setPlaylistSearch,
    setPlaylistSearchCount,
    setPlaylistSearchCurrentPos,
    setPlaylistSearchList,
    setPlaylistToDate
} from './actions';

export interface PlaylistSearchState {
    list: PlayListEntry[];
    searchString: string;
    searchCurrentPos: number;
    searchCount: number;
    searchPageSize: number;
    fromDate: Date;
    toDate: Date;
    isLoading: boolean;
}

const initialPlaylistSearchState: PlaylistSearchState = {
    list: [],
    searchString: '',
    searchCurrentPos: 0,
    searchCount: 0,
    searchPageSize: 20,
    fromDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    toDate: new Date(),
    isLoading: false
};

export function playlistSearchReducer(
    state: PlaylistSearchState = initialPlaylistSearchState,
    action: AnyAction
): PlaylistSearchState {
    if (isType(action, setPlaylistSearchList)) {
        return Object.assign({}, state, { list: action.payload });
    } else if (isType(action, setPlaylistSearch)) {
        return Object.assign({}, state, { searchString: action.payload });
    } else if (isType(action, setPlaylistSearchCount)) {
        return Object.assign({}, state, { searchCount: action.payload });
    } else if (isType(action, setPlaylistSearchCurrentPos)) {
        return Object.assign({}, state, { searchCurrentPos: action.payload });
    } else if (isType(action, setPlaylistFromDate)) {
        return Object.assign({}, state, { fromDate: action.payload });
    } else if (isType(action, setPlaylistToDate)) {
        return Object.assign({}, state, { toDate: action.payload });
    } else if (isType(action, playlistSetIsLoading)) {
        return { ...state, isLoading: action.payload };
    } else {
        return state;
    }
}
